/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ApiCaricamentoMultimedialeAuthWithCodeGet$Params {
    /**
     * id dell'evento a cui collegare il file
     */
    code: string;

    /**
     * id dell'evento a cui collegare il file
     */
    state: string;

    /**
     * id dell'evento a cui collegare il file
     */
    redirectUri: string;
}

export function apiCaricamentoMultimedialeAuthWithCodeGet(
    http: HttpClient,
    rootUrl: string,
    params: ApiCaricamentoMultimedialeAuthWithCodeGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(rootUrl, apiCaricamentoMultimedialeAuthWithCodeGet.PATH, 'get');
    if (params) {
        rb.query('code', params.code, {});
        rb.query('state', params.state, {});
        rb.query('redirectUri', params.redirectUri, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: String((r as HttpResponse<any>).body) === 'true',
            }) as StrictHttpResponse<boolean>;
        }),
    );
}

apiCaricamentoMultimedialeAuthWithCodeGet.PATH = '/api/caricamento-multimediale/auth-with-code';
